export const ENDPOINTS = {
  CLIENT_DOCUMENTS: {
    ROOT: '/clients/:clientId/documents',
    EXPIRATIONS: '/client-documents/expirations',
  },
  COMMEMORATIVE_MESSAGES: {
    GET: {
      ALL: '/commemorative-messages',
      BY_ID: '/commemorative-messages/:id',
    },
    POST: {
      CREATE: '/commemorative-messages',
    },
    PATCH: {
      BY_ID: '/commemorative-messages/:id',
    },
    DELETE: {
      BY_ID: '/commemorative-messages/:id',
    },
  },
  WHATSAPP_COSTS: {
    RATES: '/whatsapp-costs/admin/rates',
    HISTORY: '/whatsapp-costs/history',
    SIMULATE: '/whatsapp-costs/simulate',
    CAMPAIGN_PREVIEW: '/whatsapp-costs/campaign-preview',
  },
  OMIE: {
    GET: {
      DELINQUENCY_RULES: '/omie/delinquency-rules',
      STATUS_SYNC: '/omie/status-sync/status',
      CONFIGURATION: '/omie/configuration',
      COMPANIES: '/omie/companies',
      COMPANIES_IMPORT: '/omie/companies/import',
      COMPANY: '/omie/clients/:clientId/company',
      LINK_SUGGESTION: '/omie/clients/:clientId/link-suggestion',
      COMPANY_TO_IMPORT: '/omie/clients/:clientId/company-to-import',
      RECEIVABLES: '/omie/clients/:clientId/receivables',
      RECEIVABLE: '/omie/clients/:clientId/receivables/:receivableId',
      BOLETO_DOWNLOAD:
        '/omie/clients/:clientId/receivables/:receivableId/boleto/download',
      ATTACHMENT_DOWNLOAD:
        '/omie/clients/:clientId/receivables/:receivableId/attachments/:attachmentId/download',
      PAYABLES: '/omie/clients/:clientId/payables',
      PAYABLE: '/omie/clients/:clientId/payables/:payableId',
      PAYABLE_ATTACHMENT_DOWNLOAD:
        '/omie/clients/:clientId/payables/:payableId/attachments/:attachmentId/download',
    },
    POST: {
      SEND_BOLETO:
        '/omie/clients/:clientId/receivables/:receivableId/boleto/send',
      STATUS_SYNC: '/omie/status-sync',
      SEND_ATTACHMENT:
        '/omie/clients/:clientId/receivables/:receivableId/attachments/:attachmentId/send',
    },
    DELETE: {
      LINK: '/omie/clients/:clientId/link',
    },
    PUT: {
      CONFIGURATION: '/omie/configuration',
      DELINQUENCY_RULES: '/omie/delinquency-rules',
      LINK: '/omie/clients/:clientId/link',
    },
  },
  GCLICK: {
    GET: {
      CONFIGURATION: '/gclick/configuration',
      EXTERNAL_CLIENTS_SEARCH: '/gclick/external-clients/search',
      EXTERNAL_CLIENT: '/gclick/clients/:clientId/external-client',
      DEPARTMENTS: '/gclick/departments',
      PROCESSES: '/gclick/departments/:departmentId/processes',
      TASKS: '/gclick/clients/:clientId/tasks',
      TASK_ACTIVITIES: '/gclick/clients/:clientId/tasks/:taskId/activities',
      TASK_ACTIVITY_FILE_DOWNLOAD:
        '/gclick/clients/:clientId/tasks/:taskId/activities/:activityId/files/:fileKey/download',
    },
    POST: {
      PRE_TASKS: '/gclick/clients/:clientId/pre-tasks',
      SEND_TASK_ACTIVITY_FILE:
        '/gclick/clients/:clientId/tasks/:taskId/activities/:activityId/files/:fileKey/send',
    },
    DELETE: {
      LINK: '/gclick/clients/:clientId/link',
    },
    PUT: {
      CONFIGURATION: '/gclick/configuration',
      LINK: '/gclick/clients/:clientId/link',
    },
  },
  OFFICIAL_BROADCAST_CAMPAIGNS: {
    GET: {
      ALL: '/official-broadcast-campaigns',
      BY_ID: '/official-broadcast-campaigns/:id',
      ITEMS: '/official-broadcast-campaigns/:id/items',
    },
    POST: {
      CREATE: '/official-broadcast-campaigns',
      PAUSE: '/official-broadcast-campaigns/:id/pause',
      RESUME: '/official-broadcast-campaigns/:id/resume',
      CANCEL: '/official-broadcast-campaigns/:id/cancel',
    },
  },
  ACESSORIAS: {
    GET: {
      COMPANIES: '/acessorias/companies',
      COMPANIES_IMPORT: '/acessorias/companies/import',
      COMPANY: '/acessorias/clients/:clientId/company',
      COMPANY_TO_IMPORT: '/acessorias/clients/:clientId/company-to-import',
      DELIVERIES: '/acessorias/clients/:clientId/deliveries',
      REQUESTS: '/acessorias/clients/:clientId/requests',
      REQUEST_BY_ID: '/acessorias/clients/:clientId/requests/:requestId',
      PROCESSES: '/acessorias/clients/:clientId/processes',
    },
    POST: {
      REQUESTS: '/acessorias/clients/:clientId/requests',
      SEND_DELIVERY_ATTACHMENT:
        '/acessorias/clients/:clientId/deliveries/attachments/send',
    },
    DELETE: {
      LINK: '/acessorias/clients/:clientId/link',
    },
    PUT: {
      LINK: '/acessorias/clients/:clientId/link',
      REQUEST_BY_ID: '/acessorias/clients/:clientId/requests/:requestId',
    },
  },
  AUTH: {
    POST: {
      LOGIN: '/auth/login',
    },
  },
  USERS: {
    GET: {
      PROFILE: '/users/profile',
      ALL: '/users',
      BY_ID: '/users/:id',
    },
    POST: {
      CREATE: '/users',
      CREATE_PASSWORD: '/users/create-password',
      REQUEST_RESET_PASSWORD: '/users/request-reset-password',
    },
    PATCH: {
      BY_ID: '/users/:id',
      PROFILE: '/users/profile',
      PROFILE_AVATAR: '/users/profile/avatar',
    },
    DELETE: {
      BY_ID: '/users/:id',
      PROFILE_AVATAR: '/users/profile/avatar',
    },
  },
  COMPANIES: {
    GET: {
      ALL: '/companies',
      BY_ID: '/companies/:id',
    },
    POST: {
      CREATE: '/companies',
    },
    PATCH: {
      BY_ID: '/companies/:id',
    },
    DELETE: {
      BY_ID: '/companies/:id',
    },
  },
  WHATSAPP_INTEGRATIONS: {
    POST: {
      CREATE: '/whatsapp-integrations',
    },
    PATCH: {
      BY_ID: '/whatsapp-integrations/:id',
      CELL_PHONE_BY_ID: '/whatsapp-integrations/cell-phone/:id',
      ROUTING_BY_ID: '/whatsapp-integrations/:id/routing',
    },
    GET: {
      CELL_PHONE_BY_ID: '/whatsapp-integrations/cell-phone/:id',
      ROUTING: '/whatsapp-integrations/routing',
      RECONCILIATION_STATUS_BY_ID:
        '/whatsapp-integrations/:id/reconciliation-status',
    },
    DELETE: {
      OFFICIAL_TRANSPORT_BY_ID: '/whatsapp-integrations/:id/official-transport',
    },
  },
  DEPARTMENTS: {
    GET: {
      ALL: '/departments',
      BY_ID: '/departments/:id',
    },
    POST: {
      CREATE: '/departments',
    },
    PATCH: {
      BY_ID: '/departments/:id',
    },
    DELETE: {
      BY_ID: '/departments/:id',
    },
  },
  DEPARTMENT_TEMPLATES: {
    GET: {
      ALL: '/department-templates',
      BY_ID: '/department-templates/:id',
    },
    POST: {
      CREATE: '/department-templates',
      CLONE: '/department-templates/clone',
    },
    PATCH: {
      BY_ID: '/department-templates/:id',
    },
    DELETE: {
      BY_ID: '/department-templates/:id',
    },
  },
  CLIENTS: {
    GET: {
      JOURNEY_FOR_CONVERSATION: '/clients/:id/journey-for-conversation',
      ALL: '/clients',
      ACTIVE: '/clients/active',
      EXITED: '/clients/exited',
      EXITED_EXPORT: '/clients/exited/export',
      WITHOUT_CONVERSATION: '/clients/without-conversations',
      BY_ID: '/clients/:id',
      BY_ID_FOR_CONVERSATION: '/clients/:id/for-conversation',
      BY_NICHE_ID: '/clients/niche/:nicheId',
      BY_JOURNEY_ID: '/clients/journey/:journeyId',
      AVAILABLE_FOR_JOURNEY: '/clients/available-for-journey',
      DELAYED_STAGES_CACHE: '/clients/delayed-stages-cache',
    },
    POST: {
      CREATE: '/clients',
      IMPORT: '/clients/import',
      IMPORT_FROM_ACESSORIAS: '/clients/import-from-acessorias',
      IMPORT_FROM_OMIE: '/clients/import-from-omie',
      ADD_STAGE_BY_ID: '/clients/add-journey-stage/:id',
      ADD_STAGE_MANY: '/clients/add-journey-stage-many',
      ADD_TO_JOURNEY: '/clients/add-to-journey/:journeyId',
      EXPORT: '/clients/export',
      ADD_TAGS_MANY: '/clients/add-tags-many',
    },
    PATCH: {
      BY_ID: '/clients/:id',
      IMPORT_FROM_ACESSORIAS: '/clients/:id/import-from-acessorias',
      IMPORT_FROM_OMIE: '/clients/:id/import-from-omie',
      MANAGE_TAGS: '/clients/manage-tags/:id',
    },
    DELETE: {
      BY_ID: '/clients/:id',
      MANY: '/clients/remove-many',
    },
  },
  CLIENT_REFERRALS: {
    GET: {
      SUMMARY: '/client-referrals/summary',
      RANKING: '/client-referrals/ranking',
      REFERRER_DETAILS: '/client-referrals/referrers/:clientId',
    },
    PATCH: {
      COMMISSION: '/client-referrals/referred/:clientId/commission',
    },
    POST: {
      PAY_COMMISSION: '/client-referrals/referred/:clientId/commission/pay',
      REFUND_COMMISSION:
        '/client-referrals/referred/:clientId/commission/refund',
    },
  },
  CONTACTS: {
    GET: {
      ALL: '/contacts',
      DIRECTORY: '/contacts/directory',
      DIRECTORY_SYNC: '/contacts/directory/sync',
      ACCESSIBLE_CONVERSATION_BY_ID: '/contacts/:id/accessible-conversation',
      BY_ID: '/contacts/:id',
      BY_CELL_PHONE: '/contacts/by-cell-phone/:cellPhone',
      FOR_CONVERSATION: '/contacts/for-conversation/:cellPhone',
      CITIES: '/contacts/cities',
      EXPORT: '/contacts/export',
    },
    POST: {
      CREATE: '/contacts',
      SAVE_AS_NEW_CLIENT: '/contacts/save-as-new-client',
      EXPORT: '/contacts/export',
    },
    PATCH: {
      BY_ID: '/contacts/:id',
      GROUP_NAME_BY_ID: '/contacts/group-name/:id',
      DEFAULT_CONVERSATION_ROUTING:
        '/contacts/default-conversation-routing/:id',
      BLOCK_BY_ID: '/contacts/block/:id',
      TRANSFER_BY_ID: '/contacts/transfer/:id/to/:clientId',
    },
    DELETE: {
      BY_ID: '/contacts/:id',
    },
  },
  NICHES: {
    GET: {
      ALL: '/niches',
      BY_ID: '/niches/:id',
    },
    POST: {
      CREATE: '/niches',
    },
    PATCH: {
      BY_ID: '/niches/:id',
    },
    DELETE: {
      BY_ID: '/niches/:id',
    },
  },
  PLANS: {
    GET: {
      ALL: '/plans',
      PUBLIC: '/plans/public',
      BY_ID: '/plans/:id',
    },
    POST: {
      CREATE: '/plans',
    },
    PATCH: {
      BY_ID: '/plans/:id',
    },
    DELETE: {
      BY_ID: '/plans/:id',
    },
  },
  TUTORIALS: {
    GET: {
      ALL: '/tutorials',
      BY_ID: '/tutorials/:id',
    },
    POST: {
      CREATE: '/tutorials',
    },
    PATCH: {
      BY_ID: '/tutorials/:id',
    },
    DELETE: {
      BY_ID: '/tutorials/:id',
    },
  },
  HELP_CENTER: {
    CATEGORIES: '/help-center/categories',
    RESOURCES: '/help-center/resources',
    ADMIN: {
      CATEGORIES: '/help-center/admin/categories',
      RESOURCES: '/help-center/admin/resources',
    },
  },
  CLIENT_ORIGINS: {
    GET: {
      ALL: '/client-origins',
      BY_ID: '/client-origins/:id',
    },
    POST: {
      CREATE: '/client-origins',
    },
    PATCH: {
      BY_ID: '/client-origins/:id',
    },
    DELETE: {
      BY_ID: '/client-origins/:id',
    },
  },
  TRANSMISSION_LISTS: {
    GET: {
      ALL: '/transmission-lists',
      BY_ID: '/transmission-lists/:id',
    },
    POST: {
      CREATE: '/transmission-lists',
      TEXT_MESSAGE: '/transmission-lists/text-message/:id',
      FILE_MESSAGE: '/transmission-lists/file-message/:id',
      TEMPLATE_MESSAGE: '/transmission-lists/template-message/:id',
    },
    PATCH: {
      BY_ID: '/transmission-lists/:id',
    },
    DELETE: {
      BY_ID: '/transmission-lists/:id',
    },
  },
  TRANSMISSION_LIST_BATCHES: {
    POST: {
      CREATE: '/transmission-list-batches',
      START_BY_ID: '/transmission-list-batches/start/:id',
      CANCEL_BY_ID: '/transmission-list-batches/cancel/:id',
      RESUME_BY_ID: '/transmission-list-batches/resume/:id',
      PAUSE_BY_ID: '/transmission-list-batches/pause/:id',
      PROMOTE_BY_ID: '/transmission-list-batches/promote/:id',
    },
    GET: {
      BY_ID: '/transmission-list-batches/:id',
      PROGRESS_BY_ID: '/transmission-list-batches/:id/progress',
      ITEMS_BY_ID: '/transmission-list-batches/:id/items',
      PENDING_BY_TRANSMISSION_LIST_ID:
        '/transmission-list-batches/pending/:transmissionListId',
    },
  },
  DASHBOARD: {
    GET: {
      ALL: '/dashboard',
      DEMANDS: '/dashboard/demands',
      DEMAND_DETAILS: '/dashboard/demands/details',
      DEMAND_EXPORT: '/dashboard/demands/export',
      INDICATORS: '/dashboard/indicators',
      ADMIN_INDICATORS: '/dashboard/admin-indicators',
      ADMIN_COMPANY_OVERVIEW: '/dashboard/admin-company-overview',
      ADMIN_COMPANY_OVERVIEW_REFRESH_STATUS:
        '/dashboard/admin-company-overview/refresh-status',
    },
    POST: {
      ADMIN_COMPANY_OVERVIEW_REFRESH:
        '/dashboard/admin-company-overview/refresh',
    },
  },
  ASSISTANT: {
    GET: {
      MONITORS: '/assistant/monitors',
      ALERTS: '/assistant/alerts',
      RUNS: '/assistant/runs',
    },
    POST: {
      RUN: '/assistant/run',
    },
    PATCH: {
      MONITOR_BY_KEY: '/assistant/monitors/:key',
      RESOLVE_ALERT_BY_ID: '/assistant/alerts/:id/resolve',
    },
  },
  NOTIFICATIONS: {
    GET: {
      ALL: '/notifications',
      UNREAD_COUNT: '/notifications/unread-count',
      BY_ID: '/notifications/:id',
      ADMIN_ALL: '/notifications/admin',
      ADMIN_BY_ID: '/notifications/admin/:id',
    },
    POST: {
      ADMIN_CREATE: '/notifications/admin',
      ADMIN_RICH_TEXT_IMAGE: '/notifications/admin/rich-text-images',
      ADMIN_ATTACHMENT_FILE: '/notifications/admin/attachments/files',
    },
    PATCH: {
      READ_BY_ID: '/notifications/:id/read',
      UNREAD_BY_ID: '/notifications/:id/unread',
      READ_ALL: '/notifications/read-all',
      ARCHIVE_BY_ID: '/notifications/:id/archive',
      ADMIN_BY_ID: '/notifications/admin/:id',
      ADMIN_PUBLISH_BY_ID: '/notifications/admin/:id/publish',
      ADMIN_ARCHIVE_BY_ID: '/notifications/admin/:id/archive',
    },
    DELETE: {
      ADMIN_BY_ID: '/notifications/admin/:id',
    },
  },
  SYSTEM_UPDATE_NOTICES: {
    GET: {
      CURRENT: '/system-update-notices/current',
    },
    POST: {
      ADMIN_EMIT: '/system-update-notices/admin/emit',
    },
    PATCH: {
      ADMIN_DEACTIVATE: '/system-update-notices/admin/deactivate',
    },
  },
  TAX_REGIMES: {
    GET: {
      ALL: '/tax-regimes',
      BY_ID: '/tax-regimes/:id',
    },
  },
  NOTES: {
    POST: {
      CREATE: '/notes',
    },
    PATCH: {
      BY_ID: '/notes/:id',
    },
    DELETE: {
      BY_ID: '/notes/:id',
    },
  },
  TASKS: {
    GET: {
      ALL: '/tasks',
      BY_ID: '/tasks/:id',
      COMPLETED_NEXT: '/tasks/completed/next',
    },
    POST: {
      CREATE: '/tasks',
      COLUMN: '/tasks/columns',
    },
    PATCH: {
      BY_ID: '/tasks/:id',
      MOVE: '/tasks/:id/move',
      COLUMN: '/tasks/columns/:id',
      COLUMNS_REORDER: '/tasks/columns/reorder',
    },
    DELETE: {
      BY_ID: '/tasks/:id',
      COLUMN: '/tasks/columns/:id',
    },
  },
  CAC_EXPENSES: {
    GET: {
      ALL: '/cac-expenses',
      BY_ID: '/cac-expenses/:id',
    },
    POST: {
      CREATE: '/cac-expenses',
    },
    PATCH: {
      BY_ID: '/cac-expenses/:id',
    },
    DELETE: {
      BY_ID: '/cac-expenses/:id',
    },
  },
  TAGS: {
    GET: {
      ALL: '/tags',
      BY_ID: '/tags/:id',
    },
    POST: {
      CREATE: '/tags',
    },
    PATCH: {
      BY_ID: '/tags/:id',
    },
    DELETE: {
      BY_ID: '/tags/:id',
    },
  },
  SCHEDULED_MESSAGES: {
    GET: {
      ALL: '/scheduled-messages',
      BY_CONTACT_ID: '/scheduled-messages/contact/:contactId',
      BY_TRANSMISSION_LIST_ID:
        '/scheduled-messages/transmission-list/:transmissionListId',
      BY_ID: '/scheduled-messages/:id',
    },
    POST: {
      CREATE: '/scheduled-messages',
    },
    PATCH: {
      BY_ID: '/scheduled-messages/:id',
      CANCEL_BY_ID: '/scheduled-messages/cancel/:id',
    },
    DELETE: {
      BY_ID: '/scheduled-messages/:id',
    },
  },
  QUICK_MESSAGES: {
    GET: {
      FOR_CONVERSATIONS: '/quick-messages/conversations',
      BY_TRANSMISSION_LIST_ID:
        '/quick-messages/transmission-list/:transmissionListId',
      BY_ID: '/quick-messages/:id',
    },
    POST: {
      CREATE: '/quick-messages',
      TOGGLE_FAVORITE: '/quick-messages/toggle-favorite/:id',
    },
    PATCH: {
      BY_ID: '/quick-messages/:id',
    },
    DELETE: {
      BY_ID: '/quick-messages/:id',
    },
  },
  ABSENCE_MESSAGES: {
    GET: {
      ALL: '/absence-messages',
      BY_ID: '/absence-messages/:id',
    },
    POST: {
      CREATE: '/absence-messages',
    },
    PATCH: {
      BY_ID: '/absence-messages/:id',
    },
    DELETE: {
      BY_ID: '/absence-messages/:id',
    },
  },
  ABSENCE_RULES: {
    GET: {
      ALL: '/absence-rules',
      BY_ID: '/absence-rules/:id',
    },
    POST: {
      CREATE: '/absence-rules',
    },
    PATCH: {
      BY_ID: '/absence-rules/:id',
    },
    DELETE: {
      BY_ID: '/absence-rules/:id',
    },
  },
  MY_ABSENCE_MESSAGES: {
    GET: {
      ALL: '/me/absence-messages',
      BY_ID: '/me/absence-messages/:id',
    },
    POST: {
      CREATE: '/me/absence-messages',
    },
    PATCH: {
      BY_ID: '/me/absence-messages/:id',
    },
    DELETE: {
      BY_ID: '/me/absence-messages/:id',
    },
  },
  MY_ABSENCE_RULES: {
    GET: {
      ALL: '/me/absence-rules',
      BY_ID: '/me/absence-rules/:id',
    },
    POST: {
      CREATE: '/me/absence-rules',
    },
    PATCH: {
      BY_ID: '/me/absence-rules/:id',
    },
    DELETE: {
      BY_ID: '/me/absence-rules/:id',
    },
  },
  SETTINGS: {
    GET: {
      BY_KEY: '/settings/:key',
      ANNIVERSARY_MESSAGES: '/settings/anniversary-messages',
      ANNIVERSARY_MESSAGE_BY_KEY: '/settings/anniversary-message/:key',
      DEPARTMENT_ROUTING: '/settings/department-routing',
      CONVERSATION_FINISH: '/settings/conversation-finish',
      WAITING_CONVERSATION_MONITOR: '/settings/waiting-conversation-monitor',
      ATTENDANCE_SIGNATURE: '/settings/attendance-signature',
      TIME_ZONE: '/settings/time-zone',
      FAVORITES: '/settings/favorites',
    },
    POST: {
      TOGGLE_FAVORITE: '/settings/favorites/:id/toggle',
    },
    PATCH: {
      BY_KEY: '/settings/:key',
      ANNIVERSARY_MESSAGE_BY_KEY: '/settings/anniversary-message/:key',
      ANNIVERSARY_MESSAGE_ENABLED_BY_KEY:
        '/settings/anniversary-message/enabled/:key',
      DEPARTMENT_ROUTING: '/settings/department-routing',
      CONVERSATION_FINISH: '/settings/conversation-finish',
      WAITING_CONVERSATION_MONITOR: '/settings/waiting-conversation-monitor',
      ATTENDANCE_SIGNATURE: '/settings/attendance-signature',
      TIME_ZONE: '/settings/time-zone',
    },
    DELETE: {
      ANNIVERSARY_MESSAGE_BY_KEY: '/settings/anniversary-message/:key',
    },
  },
  JOURNEYS: {
    GET: {
      ALL: '/journeys',
      BY_ID: '/journeys/:id',
      TEMPLATES: '/journeys/templates',
      AVAILABLE_TO_CLIENT: '/journeys/available-for-client/:clientId',
    },
    POST: {
      CREATE: '/journeys',
      CREATE_TEMPLATE: '/journeys/create-template',
      CLONE: '/journeys/clone',
    },
    PATCH: {
      BY_ID: '/journeys/:id',
    },
    DELETE: {
      BY_ID: '/journeys/:id',
    },
  },
  JOURNEY_STAGES: {
    GET: {
      TEMPLATES: '/journey-stages/templates',
      AVAILABLE_FOR_TEMPLATE: '/journey-stages/available-for-template',
    },
    POST: {
      CREATE: '/journey-stages',
      CREATE_STAGE_FROM_TEMPLATE: 'journey-stages/from-template',
      CREATE_TEMPLATE_FROM_STAGE: 'journey-stages/to-template',
    },
    PATCH: {
      BY_ID: '/journey-stages/:id',
      ORDER: '/journey-stages/reorder',
      CATEGORIES: '/journey-stages/categories',
    },
    DELETE: {
      BY_ID: '/journey-stages/:id',
    },
  },
  CLIENT_JOURNEY_COMMENTS: {
    GET: {
      ALL: '/client-journey-comments/clients/:clientId/journeys/:journeyId',
    },
    POST: {
      CREATE: '/client-journey-comments/clients/:clientId/journeys/:journeyId',
    },
    PATCH: {
      BY_ID:
        '/client-journey-comments/clients/:clientId/journeys/:journeyId/comments/:commentId',
    },
    DELETE: {
      BY_ID:
        '/client-journey-comments/clients/:clientId/journeys/:journeyId/comments/:commentId',
    },
  },
  CATALOG_CATEGORIES: {
    GET: { ALL: '/catalog-categories' },
    POST: { CREATE: '/catalog-categories' },
    PATCH: { BY_ID: '/catalog-categories/:id' },
  },
  CATALOG: {
    GET: { ALL: '/catalog-items' },
    POST: { CREATE: '/catalog-items' },
    PATCH: { BY_ID: '/catalog-items/:id' },
  },
  OPPORTUNITIES: {
    GET: {
      ALL: '/opportunities',
      ARCHIVED: '/opportunities/archived',
      ARCHIVED_BY_ID: '/opportunities/archived/:id',
      DASHBOARD: '/opportunities/dashboard',
      DASHBOARD_LIST: '/opportunities/dashboard/opportunities',
      STAGES: '/opportunities/stages',
      BY_ID: '/opportunities/:id',
      CLIENTS: '/opportunities/clients',
      CONTACTS: '/opportunities/:id/contacts',
    },
    POST: {
      CREATE: '/opportunities',
      STAGE: '/opportunities/stages',
      NOTE: '/opportunities/:id/notes',
      CONVERSATION: '/opportunities/:id/conversations',
    },
    PATCH: {
      FUNNEL_STAGE: '/opportunities/stages/:id',
      REORDER_STAGES: '/opportunities/stages/reorder',
      RESTORE: '/opportunities/archived/:id/restore',
      BY_ID: '/opportunities/:id',
      STAGE: '/opportunities/:id/stage',
      POSITION: '/opportunities/:id/position',
    },
    DELETE: {
      FUNNEL_STAGE: '/opportunities/stages/:id',
      BY_ID: '/opportunities/:id',
    },
  },
  SERVICE_ORDERS: {
    GET: {
      ALL: '/service-orders',
      BY_ID: '/service-orders/:id',
      BY_DATE: '/service-orders/by-date',
      BY_clientId: '/service-orders/by-client/:clientId',
      BY_DEPARTMENT_ID: '/service-orders/by-department/:departmentId',
      BY_DEMAND_ID: '/service-orders/by-demand/:demandId',
    },
    POST: {
      CREATE: '/service-orders',
      RICH_TEXT_IMAGE: '/service-orders/rich-text-images',
    },
    PATCH: {
      BY_ID: '/service-orders/:id',
      UPDATE_STATUS_BY_ID: '/service-orders/update-status/:id',
    },
    DELETE: {
      BY_ID: '/service-orders/:id',
    },
  },
  SERVICE_ORDER_FILES: {
    POST: {
      CREATE: '/service-order-files',
    },
    DELETE: {
      BY_ID: '/service-order-files/:id',
    },
  },
  CONVERSATIONS: {
    GET: {
      ALL: '/conversations',
      SNAPSHOT_V2: '/conversations/v2',
      SYNC: '/conversations/sync',
      BY_ID: '/conversations/:id',
      BY_SCORE: '/conversations/by-score-type',
      BY_DEMAND_ID: '/conversations/by-demand/:demandId',
      BY_USER_ID: '/conversations/by-user/:userId',
      ACTIVE_BY_STATUS: '/conversations/active-by-status',
      NOT_ACTIVE_BY_STATUS: '/conversations/not-active-by-status',
      WITHOUT_SCORE: '/conversations/without-score',
      PREVIOUS_BY_ID: '/conversations/previous/:id',
      CONVERSATION_HISTORY_BY: '/conversations/history-by/:id',
      MESSAGES_BY_ID: '/conversations/:id/messages',
      MESSAGE_REVISIONS_BY_ID: '/conversations/:id/messages/revisions',
      MESSAGES_AROUND_BY_ID: '/conversations/:id/messages/around/:messageId',
    },
    PATCH: {
      ROUTING_AREA_BY_ID: '/conversations/:id/routing-area',
      START_BY_ID: '/conversations/start/:id',
      FINISH_BY_ID: '/conversations/finish/:id',
      FINISH_BY_IDS: '/conversations/finish-batch',
      MARK_UNREAD_BY_ID: '/conversations/:id/unread',
      MARK_READ_BY_ID: '/conversations/:id/read',
      CHANGE_CONTACT_BY_ID: '/conversations/change-contact/:id/:contactId',
      TRANSFER_BY_ID_AND_SECONDARY_USER_ID:
        '/conversations/transfer/:id/:secondaryUserId',
      TRANSFER_BY_IDS_AND_SECONDARY_USER_ID:
        '/conversations/transfer-batch/:secondaryUserId',
      TRANSFER_TO_DEPARTMENT_BY_ID_AND_DEPARTMENT_ID:
        '/conversations/transfer-to-department/:id/:departmentId',
      TRANSFER_TO_DEPARTMENT_BY_IDS_AND_DEPARTMENT_ID:
        '/conversations/transfer-to-department-batch/:departmentId',
    },
    POST: {
      TOGGLE_TAG_BY_ID_AND_TAG_ID: '/conversations/toggle-tag/:id/:tagId',
      CREATE_BY_CONTACT_ID: '/conversations/new/:contactId',
    },
  },
  MESSAGES: {
    GET: {
      SEARCH_MESSAGE: '/messages/search',
      TRANSCRIPTION_CAPABILITY: '/messages/transcription-capability',
      TRANSCRIPTION_USAGE: '/messages/transcription-usage',
    },
    POST: {
      MESSAGE: '/messages',
      TEMPLATE: '/messages/template',
      CONVERSATION_START_TEMPLATE: '/messages/template/conversation-start',
      FORWARD: '/messages/forward',
      FILE: '/messages/file',
      CONTACTS: '/messages/contacts',
      SEND_CSAT: '/messages/send-csat/:conversationId',
      REACTION: '/messages/:id/reaction',
      TRANSCRIPTION: '/messages/:id/transcription',
    },
    PATCH: '/messages',
    DELETE: '/messages/:id/:owner',
    DELETE_REACTION: '/messages/:id/reaction',
  },
  INTERNAL_CONVERSATIONS: {
    GET: {
      SNAPSHOT_V2: '/internal-chats/conversations/v2',
      SYNC: '/internal-chats/conversations/sync',
      BY_ID: '/internal-chats/conversations/:id',
      OLDER_MESSAGES_BY_IDS:
        '/internal-chats/conversations/:id/older/:messageId',
      ONLINE: '/internal-chats/online-users',
    },
    POST: {
      MESSAGE: '/internal-chats/messages/text',
      FILE: '/internal-chats/messages/file',
      CONVERSATION: '/internal-chats/conversations',
      PARTICIPANTS: '/internal-chats/conversations/:id/participants',
      LEAVE: '/internal-chats/conversations/:id/leave',
      FORWARD: '/internal-chats/messages/:id/forward',
    },
    DELETE: {
      CONVERSATION: '/internal-chats/conversations/:id',
      PARTICIPANT: '/internal-chats/conversations/:id/participants/:userId',
      AVATAR: '/internal-chats/conversations/:id/avatar',
    },
    PATCH: {
      LAST_READ_AT_BY_ID: '/internal-chats/conversations/:id/read',
      CONVERSATION: '/internal-chats/conversations/:id',
      PIN: '/internal-chats/conversations/:id/pin',
      PARTICIPANT_ROLE:
        '/internal-chats/conversations/:id/participants/:userId/role',
      AVATAR: '/internal-chats/conversations/:id/avatar',
    },
  },
  DEMANDS: {
    GET: {
      ALL: '/demands',
      QUERY: '/demands/query',
      BY_ID: '/demands/:id',
      BY_DEPARTMENT_ID: '/demands/by-department/:departmentId',
      BY_CLIENT_ID: '/demands/by-client/:clientId',
    },
    POST: {
      CREATE: '/demands',
      IMPORT: '/demands/import',
      REMOVE_MANY: '/demands/remove-many',
      SEND_SOLUTION: '/demands/:id/conversation/:conversationId/send-solution',
      SAVE_SOLUTION: '/demands/:id/conversation/:conversationId/save-solution',
    },
    PATCH: {
      BY_ID: '/demands/:id',
      TOGGLE_STATUS_BY_ID: '/demands/toggle-status/:id',
      VERIFICATION_BY_ID: '/demands/:id/verification',
      DEACTIVATE_MANY: '/demands/deactivate-many',
    },
    DELETE: '/demands/:id',
  },
  DEMAND_TEMPLATES: {
    GET: {
      ALL: '/demand-templates',
      ALL_ACTIVE: '/demand-templates/active',
      BY_ID: '/demand-templates/:id',
    },
    POST: {
      CREATE: '/demand-templates',
      CLONE: '/demand-templates/clone',
    },
    PATCH: {
      BY_ID: '/demand-templates/:id',
      TOGGLE_STATUS_BY_ID: '/demand-templates/toggle-status/:id',
    },
    DELETE: '/demand-templates/:id',
  },
  WHATSAPP: {
    GET: {
      STATUS: '/whatsapp/status',
      QR_CODE: 'whatsapp/qr-code',
    },
  },
  WHATSAPP_OFFICIAL: {
    GET: {
      TEMPLATES: '/whatsapp/templates',
      TEMPLATE: '/whatsapp/templates/:id',
      TEMPLATE_HISTORY: '/whatsapp/templates/:id/history',
      BILLING_STATUS: '/whatsapp/coex/billing-status',
    },
    POST: {
      COEX_SIGNUP: '/whatsapp/coex/signup',
      CONFIRM_BILLING_STATUS: '/whatsapp/coex/billing-status/confirm',
      TEMPLATES: '/whatsapp/templates',
      SYNC_TEMPLATES: '/whatsapp/templates/sync',
      SUBMIT_TEMPLATE: '/whatsapp/templates/:id/submit',
      CLONE_TEMPLATE: '/whatsapp/templates/:id/clone',
      TEMPLATE_EXAMPLE_MEDIA: '/whatsapp/templates/media/example',
      TEMPLATE_MEDIA: '/whatsapp/templates/media',
      CONVERSATION_START_PRESET:
        '/whatsapp/templates/presets/conversation-start',
      SYSTEM_TEMPLATE_PRESET: '/whatsapp/templates/presets/:purpose',
    },
    PATCH: {
      TEMPLATE: '/whatsapp/templates/:id',
    },
    DELETE: {
      TEMPLATE: '/whatsapp/templates/:id',
    },
  },
  WHATSAPP_PROVIDER: {
    GET: {
      GROUP_METADATA: '/providers/whatsapp/group/metadata/:groupId',
      QUEUE_COUNT_BY_WHATSAPP_INTEGRATION_ID:
        '/providers/whatsapp/queue/:whatsappIntegrationId/count',
      QUEUE_BY_WHATSAPP_INTEGRATION_ID:
        '/providers/whatsapp/queue/:whatsappIntegrationId',
    },
    DELETE: {
      QUEUE_BY_WHATSAPP_INTEGRATION_ID:
        '/providers/whatsapp/queue/:whatsappIntegrationId',
    },
  },
  STRIPE: {
    GET: {
      REACTIVATION_STATUS: '/stripe/reactivation-status',
      BILLING_STATUS: '/stripe/billing-status',
    },
    POST: {
      CHECKOUT_SESSION: '/stripe/checkout-session',
      CUSTOMER_PORTAL: '/stripe/customer-portal',
      PLAN_CHANGE: '/stripe/plan-change',
      REACTIVATION_CHECKOUT: '/stripe/reactivation-checkout',
      CANCEL_REACTIVATION_CHECKOUT: '/stripe/reactivation-checkout/cancel',
    },
  },
}
